// extracted by mini-css-extract-plugin
export default {"wrapper":"BasicDropdown_wrapper__nCUBr","contentWrapper":"BasicDropdown_contentWrapper__rWDH2","menu":"BasicDropdown_menu__8W5oP","archMenu":"BasicDropdown_archMenu__N-wGG"};